import { IConfigStore } from './ConfigStore';

export default class MemoryConfigStore<Config, Metadata> implements IConfigStore<Config, Metadata> {
  private _config: { config?: Config; metadata?: Metadata };

  constructor() {
    this._config = {};
  }

  updateConfig(config?: Config, metadata?: Metadata) {
    this._config = { metadata, config };
  }

  clear() {
    this.updateConfig();
  }

  get rawConfig() {
    return this._config || {};
  }

  get config(): any {
    return this.rawConfig.config;
  }

  get metadata(): any {
    return this.rawConfig.metadata;
  }
}
